// node-modules
import 'dl-animate';
import PubSub from 'pubsub-js';

// assets
import './expertise-tabs.scss';


document.addEventListener('DOMContentLoaded', () => {
  const SELECTORS = {
    active: 'is-active',
    loaded: 'is-loaded',
  };
  const defaults = {
    mainContainer: null,
    navItem: '[data-role*="tab-expertise-link"]',
    navItemMobile: '[data-role*="tab-list-item-mobile"]',
    tabItem: '[data-role*="tab-expertise-target"]',
    extraControl: '[data-role="switch-tab"]',
    activeClass: SELECTORS.active,
    loadedClass: SELECTORS.loaded,
    lineController: false,
  };

  class ExpertiseTabs {
    constructor(props) {
      const options = Object.assign({}, defaults, props);
      this.mainContainer = options.mainContainer;
      this.navItem = options.navItem;
      this.navItemsMobile = options.navItemMobile;
      this.tabItem = options.tabItem;
      this.extraControl = options.extraControl;
      this.activeClass = options.activeClass;
      this.loadedClass = options.loadedClass;
      this.navItems = Array.from(this.mainContainer.querySelectorAll(this.navItem));
      this.navItemsMobile = Array.from(this.mainContainer.querySelectorAll(this.navItemsMobile));
      this.tabItems = Array.from(this.mainContainer.querySelectorAll(this.tabItem));
      this.extraControls = Array.from(this.mainContainer.querySelectorAll(this.extraControl));
      this.navLine = options.navLine;
      this.lineController = options.lineController;
      this.animate = DLAnimate; // eslint-disable-line no-undef

      this.activeIndex = null;
      this.isAnimated = false;
      this.duration = 350;
      this.init();
    }

    setAttribute() {
      this.navItems.forEach((item, i) => {
        item.dataset.index = i; // eslint-disable-line no-param-reassign
        this.tabItems[i].dataset.index = i;
        this.tabItems[i].classList.add(this.loadedClass);
      });
      this.navItemsMobile.forEach((item, i) => {
        item.dataset.index = i; // eslint-disable-line no-param-reassign
      });
    }

    showActiveItem(newIndex) {
      this.animate.show(this.tabItems[newIndex], {
        name: 'tab',
        track: 'none',
        duration: this.duration,
        beforeEnter: () => {
          PubSub.publish('updateGrid');
          PubSub.publish('tab');
        },
        afterEnter: () => {
          this.isAnimated = false;
          this.activeIndex = newIndex;
        },
      });
    }

    changeTab(newIndex) {
      if (this.isAnimated || newIndex === this.activeIndex) return false;
      if (this.activeIndex === null) {
        this.navItems[newIndex].classList.add(this.activeClass);
        return this.showActiveItem(newIndex);
      }

      return this.animate.hide(this.tabItems[this.activeIndex], {
        name: 'tab',
        track: 'none',
        duration: this.duration,

        beforeLeave: () => {
          this.isAnimated = true;
          this.navItems[newIndex].classList.add(this.activeClass);
          this.navItems[this.activeIndex].classList.remove(this.activeClass);
          if (this.navItemsMobile.length) {
            this.navItemsMobile[newIndex].classList.add(this.activeClass);
            this.navItemsMobile[this.activeIndex].classList.remove(this.activeClass);
          }
        },
        afterLeave: () => this.showActiveItem(newIndex),
      });
    }

    addEvents() {
      const that = this;
      [...this.navItems, ...this.extraControls, ...this.navItemsMobile].forEach((item) => {
        item.addEventListener('click', function click(e) {
          e.preventDefault();
          that.changeTab(this.dataset.index);
          // that.showActiveItem(this.dataset.index);
        });
      });
    }

    init() {
      if (!this.navItems.length || !this.tabItems.length) return;
      this.setAttribute();
      this.addEvents();
      this.changeTab(0);
    }
  }

  // init expertise tabs
  document.querySelectorAll('[data-role="tab-list-expertise"]')
    .forEach(el => new ExpertiseTabs({
      mainContainer: el,
    }));

  // expertise drop down for mobile
  const dropContainers = Array.from(document.querySelectorAll('[data-expertise-drop]'));
  dropContainers.forEach(container => container.addEventListener('click', () => {
    dropContainers
      .filter(el => el.classList.contains(SELECTORS.active) && el !== container)
      .forEach(el => el.classList.remove(SELECTORS.active));
    container.classList.toggle(SELECTORS.active);
  }));
  if (dropContainers[0]) {
    dropContainers[0].click();
  }
});
